import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import AmenitiesTable from "components/Doobi/Amenities";

const AmenitiesRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Amenities" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={AmenitiesTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default AmenitiesRoute;
